// Expect window.PRICE_RANGE_FROM_METAFIELD = { price?, low?, high?, currency?, count? }

function toNumber(v) { const n = Number(v); return Number.isFinite(n) ? n : null; }

function findProductJsonLdTag() {
  return (
    document.querySelector('script.schemaplus-schema[type="application/ld+json"]') ||
    [...document.querySelectorAll('script[type="application/ld+json"]')]
      .find(t => /"@type"\s*:\s*"Product"/.test(t.textContent || '')) ||
    null
  );
}

function getProductNode(json) {
  return Array.isArray(json) ? json.find(x => x && x['@type'] === 'Product') : json;
}

/** Patch once: Product.offers -> Offer + PriceSpecification (min/max). */
export function patchSchemaPlusProductJsonLdOnce({ log = false } = {}) {
  const tag = findProductJsonLdTag();
  const src = window.PRICE_RANGE_FROM_METAFIELD;
  if (!tag || !src || tag.dataset.patched === '1') return false;

  let data;
  try { data = JSON.parse((tag.textContent || '').trim()); } catch { return false; }
  const product = getProductNode(data);
  if (!product) return false;

  const price = toNumber(src.price ?? src.current ?? src.low ?? src.min ?? src.high ?? src.max);
  const low   = toNumber(src.low   ?? src.min);
  const high  = toNumber(src.high  ?? src.max);
  const curr  = src.currency || 'USD';

  product.offers = {
    "@type": "Offer",
    "price": price != null ? price.toFixed(2) : undefined,
    "priceCurrency": curr,
    "availability": "https://schema.org/InStock",
    "url": product.url || location.href,
    "priceSpecification": {
      "@type": "PriceSpecification",
      "price":     price != null ? price.toFixed(2) : undefined,
      "minPrice":  low   != null ? low.toFixed(2)   : undefined,
      "maxPrice":  high  != null ? high.toFixed(2)  : undefined,
      "priceCurrency": curr
    }
  };

  tag.textContent = JSON.stringify(data, null, 2);
  tag.dataset.patched = '1';

  if (log) {
    console.groupCollapsed('Patched Product JSON-LD');
    console.log('Product.offers:', product.offers);
    console.log('Full JSON-LD:', data);
    console.groupEnd();
  }
  return true;
}

/** Start patching: run once now, then observe DOM & retry briefly if SchemaPlus injects late. */
export function startSchemaPlusJsonLdPatching(opts) {
  if (patchSchemaPlusProductJsonLdOnce(opts)) return;

  let tries = 0;
  const id = setInterval(() => {
    if (patchSchemaPlusProductJsonLdOnce(opts) || ++tries > 20) clearInterval(id);
  }, 250);

  const obs = new MutationObserver(() => {
    if (patchSchemaPlusProductJsonLdOnce(opts)) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
}

/** (Tiện test) Dump JSON-LD hiện tại. */
export function dumpCurrentSchemaJsonLd() {
  const tag = findProductJsonLdTag();
  if (!tag) { console.warn('No Product JSON-LD found'); return null; }
  try {
    const data = JSON.parse(tag.textContent);
    const product = getProductNode(data);
    console.log('JSON-LD:', data); console.log('Product:', product); console.log('Offers:', product && product.offers);
    return { data, product };
  } catch (e) { console.warn('Parse error:', e); return null; }
}
